// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1f9uM","dragIcon":"Choice_dragIcon__2cwbG","left":"Choice_left__17nGl","input":"Choice_input__1Y2pC"};